import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useMemo } from 'react'

import { QUERY_KEYS } from '~constants'
import { CategoriesListType, LocationType } from '~contexts'
import { getCategoriesList, getStatesList } from '~services'
import { CategoriesListResponse, LocationListResponse } from '~types/filters'

const { CATEGORY_LIST, OFFERS_LIST } = QUERY_KEYS

export const useGetCategoriesList = (
  options?: UseQueryOptions<CategoriesListResponse, unknown, CategoriesListResponse>
) => {
  const {
    data: filtersCategoryList,
    isLoading: isLoadingFiltersCategory,
    refetch: refetchFiltersCategory,
    status: filtersCategoryStatus,
  } = useQuery<CategoriesListResponse>([CATEGORY_LIST], getCategoriesList, { ...options })

  const categoriesList: CategoriesListType | undefined = useMemo(
    () =>
      filtersCategoryList?.categories?.map((category) => {
        return { label: category.name, value: category.id, isChecked: false }
      }),
    [filtersCategoryList]
  )

  return {
    filtersCategoryList: categoriesList,
    filtersCategoryStatus,
    isLoadingFiltersCategory,
    refetchFiltersCategory,
  }
}

export const useGetFiltersLocationList = (
  options?: UseQueryOptions<LocationListResponse, unknown, LocationListResponse>
) => {
  const {
    data: filtersLocationList,
    isLoading: isLoadingFiltersLocation,
    refetch: refetchFiltersLocation,
    status: filtersLocationStatus,
  } = useQuery<LocationListResponse>([OFFERS_LIST], getStatesList, { ...options })

  const locationList: LocationType[] | undefined = useMemo(
    () =>
      filtersLocationList?.states?.map((state) => {
        return { label: state.name, value: state.id }
      }),
    [filtersLocationList?.states]
  )

  return {
    filtersLocationStatus,
    isLoadingFiltersLocation,
    locationList,
    refetchFiltersLocation,
  }
}
